import React from 'react'
import { 
    Space, 
    Row, 
    Col, 
} from "antd";
import { formatDate } from '../../../Helpers/Utils/Common';
import { FORM } from "../../../Constants/doctor";
import { getResidentDetails, getRole, getUser } from '../../Helpers/Utilities/Common';

const FormFooter = ({patient, type, tab}) => {
    const role = getRole();
    const user = getUser();
    const details = tab === 'assessment' ? getResidentDetails(patient?.added_by) : getResidentDetails(user)

    return (
        <div>
            <Row 
              className="rx-footer"
              id='footer-v2'
            >
              <Col span={24}>
                <Row>
                  <Col span={12} align="left">
                    {
                      (type === "followup") && (
                        <Space direction="vertical">
                          Follow Up Schedule:
                          <strong>{patient?.outpatients ? formatDate(patient?.outpatients[0]?.followup_on) : ""}</strong>
                        </Space>
                      )
                    }
                  </Col>
                  <Col span={12} align="right">
                    {
                      tab === 'assessment' ? (
                        <>
                          <strong>{details[0]?.name}</strong>
                          <div>{details[0]?.license_no}</div>
                          <div>{details[0]?.ptr_no}</div>
                        </>
                      ) : (role === "pcp" || role === "specialist" || role === "director") ? (
                          <>
                              <strong>{FORM.footer.doctor_name}</strong>
                              <div>{FORM.footer.license}</div>
                              <div>{FORM.footer.ptr}</div>
                          </>
                      ) : (
                          <>
                              <strong>{details[0]?.name}</strong>
                              <div>{details[0]?.license_no}</div>
                              <div>{details[0]?.ptr_no}</div>
                          </>
                      )
                    }
                  </Col>
                </Row>
                {/* <Row>
                  <Col span={24} className="center mt-4">
                    PLEASE CALL CLINIC TO CONFIRM APPOINTMENT 
                  </Col>
                </Row> */}
              </Col>
            </Row>
        </div>
    )
}

export default FormFooter
